export default "__VITE_PUBLIC_ASSET__07188e0c__"